import { Phone, Mail, MessageCircle, MapPin, Instagram, Facebook, Youtube, Globe, BadgeCheck } from "lucide-react";

const SOCIAL = { instagram: [Instagram, "Instagram"], facebook: [Facebook, "Facebook"], youtube: [Youtube, "YouTube"], website: [Globe, "Website"], google_maps: [MapPin, "Google Maps"] };
const LEGAL = { privacy_url: "Privacy Policy", terms_url: "Terms of Use", refund_url: "Refund Policy" };

/** Smart footer: renders ONLY populated fields; whole sections disappear when empty. No placeholders, no invented data. */
export const SiteFooter = ({ brand, branch, website, large = false }) => {
  const w = website || {};
  const social = Object.entries(w.social || {}).filter(([k, v]) => v && SOCIAL[k]);
  const legal = Object.entries(w.legal || {}).filter(([k, v]) => v && LEGAL[k]);
  const hasContact = w.address || w.contact_phone || w.whatsapp || w.email;
  return (
    <footer className={`os-footer ${large ? "large" : ""}`} data-testid="site-footer">
      <div className="os-footer-grid">
        {w.about && <section data-testid="footer-about"><h3>About</h3><p style={{ margin: 0, whiteSpace: "pre-line" }}>{w.about}</p></section>}
        {hasContact && (
          <section data-testid="footer-contact">
            <h3>{branch?.name || "Contact"}</h3>
            {w.address && <p style={{ margin: "0 0 6px", display: "flex", gap: 6 }}><MapPin size={14} style={{ flexShrink: 0, marginTop: 3 }} /><span data-testid="footer-address">{w.address}</span></p>}
            {w.contact_phone && <a href={`tel:+${w.contact_phone.length === 10 ? "91" : ""}${w.contact_phone}`} data-testid="footer-phone"><Phone size={14} />{w.contact_phone.length === 10 ? `+91 ${w.contact_phone}` : `+${w.contact_phone}`}</a>}
            {w.whatsapp && <a href={`https://wa.me/${w.whatsapp.length === 10 ? "91" : ""}${w.whatsapp}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp"><MessageCircle size={14} />WhatsApp</a>}
            {w.email && <a href={`mailto:${w.email}`} data-testid="footer-email"><Mail size={14} />{w.email}</a>}
          </section>
        )}
        {social.length > 0 && (
          <section data-testid="footer-social"><h3>Follow us</h3>
            <div className="os-social">{social.map(([k, v]) => { const [Icon, label] = SOCIAL[k]; return <span key={k} className="os-social-item"><a href={v} target="_blank" rel="noreferrer" aria-label={label} title={label} data-testid={`footer-social-${k}`}><Icon size={large ? 46 : 18} /></a>{large && <span className="os-social-label">{label}</span>}</span>; })}</div>
          </section>
        )}
      </div>
      {w.fssai_license_no && <p style={{ margin: "16px 0 0", display: "flex", alignItems: "center", gap: 6, fontSize: 12 }} data-testid="footer-fssai"><BadgeCheck size={14} />FSSAI Lic. No. {w.fssai_license_no}</p>}
      <div className="os-footer-legal">
        {legal.map(([k, v]) => <a key={k} href={v} target="_blank" rel="noreferrer" data-testid={`footer-legal-${k}`}>{LEGAL[k]}</a>)}
        <span style={{ marginLeft: "auto" }} data-testid="footer-brand">© {new Date().getFullYear()} {brand?.name}</span>
      </div>
    </footer>
  );
};
